export default __webpack_public_path__ + "static/media/bazzle3.e01f952b.png";